import i18n from "@/locales/index"
export default [
  [
    {
      name: "Password",
      label: i18n.tc("password"),
      type: "password",
      placeholder: i18n.tc("enterASecurePassword"),
      required: true,
    },
    {
      name: "PasswordConfirmation",
      label: i18n.tc("confirmPassword"),
      type: "password",
      placeholder: i18n.tc("repeatYourPassword"),
      required: true,
    },
  ],
]
